import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from 'hooks';
import { osName } from 'react-device-detect';

function HandleAllInOneLinksPage() {
  const urlQuery = useQuery();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const notFound = () => {
      // navigate('/notFound', { replace: true });
    };
    /**
     * Example link
     * https://all-in-one-bravo-sit.generali.com.hk/links/allinone/?apn=com.generali.allinone.sit&afl=https://install.appcenter.ms/orgs/GLHK/apps/Generali-All-in-one-SIT-Android&isi=1614568835&ibi=com.generali.allinone.sit&ifl=https://testflight.apple.com/v1/app/1614568835&link=https://all-in-one-bravo-sit.generali.com.hk/register?email%3Dliven.wang%40generali.com.hk%26policyNumber%3D88000954%26memberId%3D246844%26memberType%3D1%26memberName%3DGiv+954+Sur+954%26principalName%3DGiv+954+Sur+954
     */
    const registrationPart = urlQuery.get('link');
    console.log(urlQuery);

    const pathname = location.pathname;
    if ((osName == 'iOS' || osName == 'Android') && !pathname.includes('eob')) {
      window.location.href =
        osName === 'Android'
          ? 'https://play.google.com/store/apps/details?id=com.generali.allinone'
          : 'https://apps.apple.com/hk/app/generali-genbravo/id1607457003';
      return;
    }

    if (!registrationPart && !pathname.includes('eob') && !pathname.includes('auth-login')) {
      return notFound();
    }

    if (registrationPart) {
      const registrationLink = new URL(registrationPart);

      if (window.location.hostname !== registrationLink.hostname) {
        return notFound();
      }
      console.log(registrationLink.search, 'registrationLink.search');

      const search1 = new URLSearchParams(window.location.search);

      if (['/register'].includes(registrationLink.pathname)) {
        return navigate(
          {
            pathname: registrationLink.pathname.replace('/register', '/register/EbconnectPolicy'),
            search: registrationLink.search + (search1.get('language') ? `&language=${search1.get('language')}` : ''),
          },
          { replace: true },
        );
      }
    }
    if (pathname.includes('eob')) {
      return navigate(
        {
          pathname: pathname.replace('/links/allinone', ''),
        },
        { replace: true },
      );
    }

    if (pathname.includes('auth-login')) {
      return navigate(
        {
          pathname: '/login',
        },
        { replace: true },
      );
    }
    notFound();
  }, [urlQuery, navigate, location]);

  return <></>;
}

export default HandleAllInOneLinksPage;
